module.exports = __webpack_public_path__ + "static/media/payrollnew1.ae3c70b5.svg";